// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"first-text-module--textWrapper--gFdvs","textBox":"first-text-module--textBox--3PEvs"};